var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 90",
    role: "img",
    "aria-label": "SAT Prep",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6,4) scale(0.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,5 L87,20 V47 C87,73 50,93 50,93 C50,93 13,73 13,47 V20 Z",
    fill: "#800020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,52 L43,67 L75,29",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 47,
    fontFamily: "-apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#800020"
  }, "SAT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 68,
    fontFamily: "-apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: 3,
    fill: "#5c0017"
  }, "PREP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c64eedcb0021a5a007cb367146eb57bc.svg";
export { ForwardRef as ReactComponent };